const RootNameSpace = 'root';

const RootActionTypes = Object.freeze({
    SetHost: 'SetHost',

});

const RootMutationTypes = Object.freeze({
    SetHost: 'SetHost',
    SetSettings: 'SetSettings',
    SetOrigin: 'SetOrigin',
});

const RootGetterTypes = Object.freeze({
    GetHost: 'GetHost',
    GetOrigin: 'GetOrigin',
    GetSettings: 'GetSettings',
});

export {
    RootNameSpace,
    RootActionTypes,
    RootMutationTypes,
    RootGetterTypes,
};